module.exports = __webpack_public_path__ + "static/media/icon-nav-buy-sell.05bf1b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-buy-sell.svg
// module id = 1213
// module chunks = 19